export const paywall = {
  notArchive: {
    entityId: "511139",
    name: "Not archive",
  },
  notVelocity: {
    entityId: "511138",
    name: "Not velocity",
  },
  velocity: {
    entityId: "507836",
    name: "velocity",
  },
};
